import React, { useState, useEffect } from 'react';

import { callApiGet, callApiPut, callApiPost } from '../Helper/Network';

import { HyappEdit, SurfaceEdit, ActionEdit, EntryEdit, MoisEdit } from '../Helper/Form'

import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../locale/useTranslation';
import { update } from 'lodash';
function Editor(props) {
  const { t, language, setLanguage, subscribe, tLang, tTag } = useTranslation();
  const location = useLocation().pathname.replace("/edit", "").replace("/view", "");

  const [firstLoad, setFirstLoad] = useState(true);
  const [data, setData] = useState(undefined);
  const [headers, setHeaders] = useState(undefined);
  const [references, setReferences] = useState(undefined);
  const [dataId, setDataId] = useState(undefined);

  //specfic for surfaces
  const [surfaceToDelete, setSurfaceToDelete] = useState([]);
  const [surfaces, setSurfaces] = useState([]);

  //specific for non conformites
  const [actions, setActions] = useState([]);

  // spécifique pour les non conformités
  const [actionsDeleted, setActionsDeleted] = useState([]); // Ajouté pour suivre les suppressions


  //specific for checklist
  const [entries, setEntries] = useState([]);

  const [tempHeader, setTempHeader] = useState(0);
  
  const navigate = useNavigate();
	const goBack = () => {
		navigate(-1);
	}

  //specific for date

  const loadData = async () => {
    try {
      var url = location;
      
      //load data element
      const res = await callApiGet(url + "/edit", navigate);

      //check for headers
      res.headers  ? setHeaders(res.headers) : setHeaders(undefined);
      res.id ? setDataId(res.id): setDataId(undefined);

      if (res.data) {
        setData(res.data)
      }
      else {
        //in create mode, create empty references
        var emptyData = [];
        res.headers.map((header) => {
          if (header.type === "boolean") {
            // Lecture seule décochée par défaut pour les établissements
            if (header.value==="et_acces_donne") {
              return emptyData[header.value] = false;
            }
            return emptyData[header.value] = false;
          }
          // Tous les jours sont sélectionnés par défaut si on définit un établissement
          if (header.value==="et_jour_ouverture") {
            return emptyData[header.value] = [1,2,3,4,5,6,7];
          }
          // Tous les modules sont sélectionnés par défaut si on définit un établissement
          if (header.value==="et_module") {
            return emptyData[header.value] = [1,2,3,4,5,6,7,8,10,11];
          }
          // Tous les types de produits livrés par défaut si on définit un fournisseur
          if (header.value==="fou_type_produit") {
            return emptyData[header.value] = [1,2,3,4,5,6];
          }
          if (header.value==="type_abo") {
            return emptyData[header.value] = 1;
          }
          return emptyData[header.value] = null;
        });
        emptyData[dataId] = -1;
        setData(emptyData);
      }

      // if element use external references
      if (res.references) {
        var loadedReferences = await Promise.all(res.references.map(async (reference) => {
          //load references
          var res2 = await callApiGet(url + "/select/" + reference, navigate);
          var result = [];
          var translatedResult = [];
          const availableLocales = process.env.REACT_APP_AVAILABLE_LOCALES.split(",");
          res2.forEach((obj) => {
            var trObj = {
              value: obj.value,
              label: obj.label
            }
            if (obj.translate === undefined || obj.translate!== 0) {
              availableLocales.forEach((lang) => {
                trObj["label-" + lang] = tLang(obj.label, lang);
              });
            }
            translatedResult.push(trObj);
          });

          result[reference] = translatedResult;
          return { ref: reference, data: translatedResult };
        }));

        var finalReferences = [];
        loadedReferences.map((refe) => {
          finalReferences[refe.ref] = refe.data;
          return undefined;
        })
        setReferences(finalReferences);
      }

      if (props.mode && props.mode === "zone" && res.data.surfaces) {
        setSurfaces(res.data.surfaces);
      }
      if (props.mode && props.mode === "non_conformite" && res.data.actions) {
        setActions(res.data.actions);
      }
      if (props.mode && props.mode === "checklist" && res.data.entries) {
        setEntries(res.data.entries);
      }

    }
    catch (error) {

    }
  }

  const updateData = (element_index, value) => {
    var cloned = [];
    headers.forEach((h) => {
      cloned[h.value] = data[h.value];
    })
    cloned[dataId] = data[dataId];
    cloned[element_index] = value;

    if (element_index === 'type_enceinte_tyen_id') {
      if (value === 1) { //froid négatif
        cloned['enc_min_temp']=null;
        cloned['enc_warn_temp']=-18;
        cloned['enc_max_temp']=-15;
      }
      if (value === 2) { //froid positif
        cloned['enc_min_temp']=0;
        cloned['enc_warn_temp']=4;
        cloned['enc_max_temp']=7;
      }
      if (value === 3) { //Maintien au chaud
        cloned['enc_min_temp']=60;
        cloned['enc_max_temp']=null;
      }
      setTempHeader(tempHeader + 1);
    }
    
    setData(cloned);
    
  }

  const save = async () => {
    var requestBody = Object.assign({}, data);

      // 2. Conversion du tableau de mois [1, 5] en string "01,05"
      if (requestBody["chk_mois"] && Array.isArray(requestBody["chk_mois"])) {
        requestBody["chk_mois"] = requestBody["chk_mois"]
          .map(m => m.toString().padStart(2, '0')) // Ajoute le 0 devant si nécessaire
          .join(","); // Joint avec une virgule
      }

    if (props.mode && props.mode === "zone") {
      var newSurfaces = [];
      var updateSurfaces = [];

      surfaces.forEach((surface) => {
        if (surface.sur_id === -1) {
          newSurfaces.push(surface);
        }
        else {
          updateSurfaces.push(surface);
        }
      })

      requestBody["surfaces"] = newSurfaces;
      requestBody["surfaceToDelete"] = surfaceToDelete;
      requestBody["surfaceToUpdate"] = updateSurfaces;
    }
    if (props.mode && props.mode === "non_conformite") {
        // Filtrage des actions selon leur état
        const actions_added = actions
          .filter(a => a.act_id === -1)
          .map(a => ({ act_description: a.act_description, act_prevue_le: a.act_prevue_le, act_realisee_le: a.act_realisee_le }));

        const actions_updated = actions
          .filter(a => a.act_id !== -1)
          .map(a => ({ 
            act_id: a.act_id, 
            act_description: a.act_description, 
            act_prevue_le: a.act_prevue_le,
            act_realisee_le: a.act_realisee_le
          }));

        // On injecte les trois tableaux attendus par le backend
        requestBody["actions_added"] = actions_added;
        requestBody["actions_updated"] = actions_updated;
        requestBody["actions_deleted"] = actionsDeleted;
        
        // On retire l'ancien champ "actions" s'il existe pour éviter les conflits
        delete requestBody["actions"];
    }
    if (props.mode && props.mode === "checklist") {
      var newEntries = [];
      entries.forEach((entry) => {
        var entry = {
          chken_nom: entry.chken_nom,
          chken_type: entry.chken_type,
          chken_options: entry.chken_options,
          chken_conformite: entry.chken_conformite
        }
        newEntries.push(entry);
      })
      requestBody["entries"] = newEntries;
      if (requestBody["frck_id"] != 6) {
        requestBody["chk_mois"] = null;
      }
    }

    try {
      if (!data[dataId] || data[dataId] === -1) { 
        //create element
        await callApiPut(location, requestBody, navigate);
      }
      else { //update element
        await callApiPost(location, requestBody, navigate);
      }
      navigate(-1);
    }
    catch (error) {

    }    
  }

  useEffect(() => {
    if (firstLoad) {
      loadData();
      setFirstLoad(false);
    }
  }, [data, headers, references])



  // SURFACE Spécifique
  const addSurface = () => {
    var newSurfaces = [...surfaces, { sur_id: -1, sur_nom: "", frequence_surface_frsu_id: null, sur_mois: null} ];
    setSurfaces([...newSurfaces]);
  }
  const modifySurface = (index, surface) => {
    var newSurfaces = [...surfaces];
    newSurfaces[index]=surface;
    setSurfaces([...newSurfaces]);
  }
  const deleteSurface = (index) => {
    var newSurfaces = []
    var newDelete = [...surfaceToDelete]
    surfaces.forEach((surface, id) => {
      if (index !== id) {
        newSurfaces.push({...surface})
      }
      else {
        if (surface.sur_id !== -1) {
          newDelete.push(surface);
        }
      }
    })
    setSurfaces([...newSurfaces]);
    setSurfaceToDelete([...newDelete]);
  }

  var zoneElements = []
  if (props.mode && props.mode === "zone") {
    if (surfaces) {
      zoneElements = surfaces.map((surface, index) => {
        return (
          <SurfaceEdit
            key={surface.sur_id + " " + index}
            index={index}
            surface={surface}
            callback={modifySurface}
            deleteCallback={deleteSurface}
            />
        )})
    }
  }
  //-------------------

  //non conformité spécifique
  const addAction = () => {
    var newActions = [...actions, { act_id: -1, act_description: "", act_prevue_le: null, act_realisee_le: null} ];
    setActions([...newActions]);
  }
  const modifyAction = (index, action) => {
    var newActions = [...actions];
    newActions[index]=action;
    setActions([...newActions]);
  }
  const deleteAction = (index) => {
    const actionToDelete = actions[index];
    
    // Si l'action existe déjà en BDD (ID positif), on la stocke pour le serveur
    if (actionToDelete.act_id && actionToDelete.act_id !== -1) {
      setActionsDeleted([...actionsDeleted, { act_id: actionToDelete.act_id }]);
    }
    
    var newActions = [...actions];
    newActions.splice(index, 1);
    setActions(newActions);
  }

  var actionElements = []
  if (props.mode && props.mode === "non_conformite") {
    if (actions) {
      actionElements = actions.map((action, index) => {
        return (
          <ActionEdit
            key={action.act_id + " " + index}
            index={index}
            action={action}
            callback={modifyAction}
            deleteCallback={deleteAction}
            />
        )
      })
    }
  }
  //-----------------------------


  //checklist spécifique
  const addEntry = () => {
    var newEntries = [...entries, { chken_id: -1, chken_nom:'', chken_type: '', chken_options: '', chken_conformite: false} ];
    setEntries([...newEntries]);
  }
  const modifyEntry = (index, entry) => {
    var newEntries = [...entries];
    newEntries[index]=entry;
    setEntries([...newEntries]);
  }
  const deleteEntry = (index) => {
    var newEntries = [...entries]
    newEntries.splice(index, 1)
    setEntries([...newEntries]);
  }

  const editMonth = (newValues) => {
    setData({ ...data, chk_mois: newValues });
  }

  var entryElements = []
  if (props.mode && props.mode === "checklist") {
    if (entries) {
      entryElements = entries.map((entry, index) => {
        return (
          <EntryEdit
            key={entry.chken_id + " " + index}
            index={index}
            entry={entry}
            callback={modifyEntry}
            deleteCallback={deleteEntry}
            />
        )
      })
    }
  }


  //-----------------------------



  return (
    <>
      <div className="columns">
        <div className="column">
          <h1 className="hyappTitle">{t(props.title)}</h1>
        </div>
      </div>
      <div className="columns is-multiline is-vcentered">
      {
        headers ?
          headers.map((header, index) => {
            var ref = undefined;
            var sortRef = false;
            if (header.reference && references && header.reference in references) {
              ref = references[header.reference];
              //if references must be sort by name
              if (header.sortReference) {
                sortRef = header.sortReference;
              }
            }
            

            if (header.value === 'enc_min_temp' || header.value === 'enc_max_temp') {
              return (<HyappEdit 
                key={index + " " + tempHeader} 
                label={header.label} 
                type={header.type} 
                value={data[header.value]} 
                reference={ref}
                element={header.value}
                callback={updateData} 
                sortReference={sortRef}/>)
            }
            if (header.value === 'frck_id' && data[header.value] == 6) { //spécifique pour les pluri annuels des checklist
              return <>
                <HyappEdit 
                  key={index} 
                  label={header.label} 
                  type={header.type} 
                  value={header.translateTag ? tTag(data[header.value]) : data[header.value]} 
                  reference={ref}
                  element={header.value}
                  callback={updateData}
                  sortReference={sortRef} />
                  <MoisEdit selectedMonths={data && data["chk_mois"] ? data["chk_mois"]: []} onChange={editMonth} />

              </>
            }
            return (<HyappEdit 
                key={index} 
                label={header.label} 
                type={header.type} 
                value={header.translateTag ? tTag(data[header.value]) : data[header.value]} 
                reference={ref}
                element={header.value}
                callback={updateData}
                sortReference={sortRef} />)

          })
          : <></>
      }
      {
        props.mode && props.mode === "zone" ?
          (
            <>
            <div className="column is-one-fifth label-right">
              <label className="label">{t("Surface et matériels associés")}</label>
            </div>
            <div className="column is-four-fifths display-value">
              <div className="columns is-multiline is-vcentered">
              {
                zoneElements
              }
              <Link className="button is-warning" onClick={addSurface}><i className="fa fa-plus" /></Link>
              </div>
            </div>
            </>
          )
        :
        <></>
      }
      {
        props.mode && props.mode === "non_conformite" ?
          (
            <>
            <div className="column is-one-fifth label-right">
              <label className="label">{t("Actions")}</label>
            </div>
            <div className="column is-four-fifths display-value">
              <div className="columns is-multiline is-vcentered">
              {
                actionElements
              }
              <Link className="button is-warning" onClick={addAction}><i className="fa fa-plus" />{t("Nouvelle action")}</Link>
              </div>
            </div>
            </>
          )
        :
        <></>
      }      
      {
        props.mode && props.mode === "checklist" ?
          (
            <>
            <div className="column is-one-fifth label-right">
              <label className="label">{t("Entrée")}</label>
            </div>
            <div className="column is-four-fifths display-value">
              <div className="columns is-multiline is-vcentered">
              {
                entryElements
              }
              <Link className="button is-warning" onClick={addEntry}><i className="fa fa-plus" />{t("Nouvelle entrée")}</Link>
              </div>
            </div>
            </>
          )
        :
        <></>
      }            
      </div>
      {
        <>
        <Link className="button is-warning" onClick={save}><i className="fa fa-save" />{t("Enregistrer")}</Link>
        <Link className="button is-dark" onClick={goBack}>{t("Annuler")}</Link>
        </>
      }
    </>
  );
}

export default Editor;

//chargement d'un element
export const editorParseUrl = async ({ params }) => {
  const { element_id } = params;
  return element_id;
}



